import React from 'react';
import { Box, Container, Typography, Tabs, Tab } from '@mui/material';
import { Translate } from '@mui/icons-material';
import { useLocation, useNavigate } from 'react-router-dom';
import { t } from '../i18n';

const TABS = [
  { path: '/', en: 'Postal Code', ja: '郵便番号' },
  { path: '/browse', en: 'Browse', ja: '地域から探す' },
  { path: '/reverse', en: 'Reverse Search', ja: '逆引き検索' },
  { path: '/api-docs', en: 'API Docs', ja: 'APIドキュメント' },
  { path: '/about', en: 'About', ja: '情報' },
];

const NavBar = () => {
  const location = useLocation();
  const navigate = useNavigate();

  const current = TABS.findIndex((tab) => tab.path === location.pathname);
  const value = current === -1 ? false : current;

  return (
    <Box
      component="header"
      sx={{
        bgcolor: 'background.paper',
        borderBottom: '1px solid',
        borderColor: 'divider',
      }}
    >
      <Container maxWidth="md">
        <Box sx={{ display: 'flex', alignItems: 'center', pt: 2, pb: 1 }}>
          <Translate sx={{ fontSize: 32, mr: 1.5, color: 'secondary.main' }} />
          <Typography variant="h5" component="h1" fontWeight="bold">
            {t('Japan Postal Code Lookup', '日本郵便番号検索')}
          </Typography>
        </Box>
        <Tabs
          value={value}
          onChange={(_, idx) => navigate(TABS[idx].path)}
          variant="scrollable"
          scrollButtons="auto"
          textColor="secondary"
          indicatorColor="secondary"
        >
          {TABS.map((tab) => (
            <Tab key={tab.path} label={t(tab.en, tab.ja)} />
          ))}
        </Tabs>
      </Container>
    </Box>
  );
};

export default NavBar;
